export default "__VITE_PUBLIC_ASSET__04a78dbe__"